<template>
  <v-app>
    <v-container fluid class="pb-0">
      <v-row v-if="$insertAccess($route.path)">
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Others Info</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form
                  @submit.prevent="submit"
                  ref="addMoneyRequisition"
                  id="addMoneyRequisition"
                >
                  <v-row class="pa-2">
                    <v-col cols="12">
                      <v-text-field
                        v-if="!isEntryMode"
                        label="Requisition Code"
                        density="compact"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="moneyRequisitionCode"
                        autocomplete="off"
                        :disabled="true"
                        clearable
                      ></v-text-field>

                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="employee_id.value.value"
                        :items="getHrmEmployeeList"
                        :item-title="(item) => `${item.name} - ${item.code || item.employee_code || ''}`"
                        item-value="id"
                        :error-messages="employee_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                        :loading="loading"
                      >
                        <template #label>
                          Employee
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-textarea
                        label="Project"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="purpose.value.value"
                        :error-messages="purpose.errorMessage.value"
                        autocomplete="off"
                        rows="3"
                        clearable
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Item Info</v-expansion-panel-title
              >
              <v-expansion-panel-text class="item-info-form" style="padding: 8px;">
                <v-form
                  @submit.prevent="submit"
                  ref="addMoneyRequisition"
                  id="addMoneyRequisition"
                >
                  <v-row dense class="ma-0">
                    <v-col cols="12" md="6" class="pa-1">
                      <v-text-field
                        label="Description"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="itemDescription"
                        autocomplete="off"
                        clearable
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" class="pa-1">
                      <v-text-field
                        label="Amount"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="itemAmount"
                        type="number"
                        min="0.01"
                        step="0.01"
                        autocomplete="off"
                        clearable
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" class="pa-1 d-flex align-center">
                      <v-btn class="bg-primary" @click="addItem">ADD</v-btn>
                    </v-col>
                  </v-row>

                  <!-- Items Table -->
                  <v-row dense class="ma-0 mt-1">
                    <v-col cols="12" class="pa-1">
                      <v-table
                        density="compact"
                        :loading="loading"
                        fixed-header
                        class="table-dotted-border-bottom"
                        style="height: 35vh; overflow-y: auto"
                      >
                        <thead>
                          <tr>
                            <th class="text-center">SL</th>
                            <th class="text-left" style="width: 50%">
                              Description
                            </th>
                            <th class="text-right" style="width: 30%">
                              Amount
                            </th>
                            <th class="text-center" style="width: 20%">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in items"
                            v-if="items.length > 0"
                            :key="index"
                          >
                            <td class="text-center" style="padding: 4px;">{{ index + 1 }}</td>
                            <td class="text-left" style="white-space: normal; padding: 4px;">
                              {{ item.description }}
                            </td>
                            <td class="text-right" style="padding: 4px;">
                              {{ formatCurrency(item.amount) }}
                            </td>
                            <td class="text-center" style="padding: 4px;">
                              <v-icon
                                size="small"
                                color="red"
                                class="delete-button"
                                @click="removeItem(index)"
                              >
                                mdi-delete
                              </v-icon>
                            </td>
                          </tr>

                          <tr v-else-if="loading == true">
                            <td colspan="4" class="text-center">
                              <v-skeleton-loader
                                type="heading"
                                :loading="loading"
                              />
                            </td>
                          </tr>
                          <tr v-else>
                            <td colspan="4" class="text-center text-red">
                              You have no item
                            </td>
                          </tr>
                        </tbody>
                        <tfoot v-if="items.length > 0">
                          <tr class="bg-grey-lighten-3">
                            <td colspan="2" class="text-right font-weight-bold">
                              Total Amount
                            </td>
                            <td class="text-right font-weight-bold">
                              {{ formatCurrency(totalAmount) }}
                            </td>
                            <td></td>
                          </tr>
                        </tfoot>
                      </v-table>
                    </v-col>
                  </v-row>
                  <!-- Close Items Table -->

                  <v-divider class="my-2"></v-divider>
                  <v-card-actions class="pa-1">
                    <v-row dense class="ma-0">
                      <v-col cols="12" class="pa-1">
                        <v-layout class="justify-end">
                          <!-- Show DRAFT and POST buttons when creating -->
                          <template v-if="isEntryMode">
                            <v-btn
                              class="bg-grey-darken-1 me-2"
                              variant="flat"
                              @click="submitForm(0, items)"
                              :loading="loading && currentButton === 'draft'"
                            >
                              DRAFT
                            </v-btn>
                            <v-btn
                              class="bg-primary"
                              variant="flat"
                              @click="submitForm(1, items)"
                              :loading="loading && currentButton === 'post'"
                            >
                              POST
                            </v-btn>
                          </template>
                          <!-- Show single UPDATE button when editing -->
                          <template v-else>
                            <v-btn
                              class="bg-primary"
                              variant="flat"
                              @click="submitForm(currentStatus, items)"
                              :loading="loading && currentButton === 'update'"
                            >
                              UPDATE
                            </v-btn>
                          </template>
                        </v-layout>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, computed } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";

export default {
  components: {},
  data: () => ({
    panel: [0],
    panel2: [0],
    loading: false,
    errorMessages: "",
    moneyRequisitionCode: "",
    isEntryMode: true,
    items: [],
    itemDescription: "",
    itemAmount: null,
  }),
  watch: {},
  created() {
    if (this.$store.getters.getHrmEmployeeList.length === 0) {
      this.loading = true;
      this.$store.dispatch("getHrmEmployeeList").then(() => {
        this.loading = false;
      });
    }
  },
  computed: {
    getHrmEmployeeList() {
      return this.$store.getters.getHrmEmployeeList;
    },
    totalAmount() {
      return this.items.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
    },
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value || 0);
    },
    addItem() {
      if (!this.itemDescription || !this.itemDescription.trim()) {
        toast.error("Please enter description");
        return;
      }
      if (!this.itemAmount || parseFloat(this.itemAmount) < 0.01) {
        toast.error("Please enter a valid amount (minimum 0.01)");
        return;
      }

      const item = {
        description: this.itemDescription.trim(),
        amount: parseFloat(this.itemAmount),
      };

      this.items.push(item);
      this.itemDescription = "";
      this.itemAmount = null;
    },
    removeItem(index) {
      if (confirm("Are You Sure?")) {
        this.items.splice(index, 1);
      }
    },
    loadRequisition(id) {
      this.loading = true;
      this.$store
        .dispatch("getMoneyRequisitionById", id)
        .then((response) => {
          // Handle response structure: 
          // Backend returns {success: true, data: [...]}
          // Store action resolves with response.data which is {success: true, data: [...]}
          let data = null;
          
          // Backend show() returns {success: true, data: [...]} where data is an array
          // Store resolves with response.data = {success: true, data: [...]}
          if (response && response.success && response.data) {
            // response.data is the array from backend
            if (Array.isArray(response.data) && response.data.length > 0) {
              data = response.data[0];
            }
          } else if (response && response.data) {
            // Fallback: if response.data is directly the array
            if (Array.isArray(response.data) && response.data.length > 0) {
              data = response.data[0];
            } else if (response.data.id) {
              // If it's already the object
              data = response.data;
            }
          } else if (Array.isArray(response) && response.length > 0) {
            // Fallback: if response is directly the array
            data = response[0];
          }
          
          if (data) {
            this.moneyRequisitionCode = data.code;
            this.employee_id.value.value = data.employee_id;
            this.purpose.value.value = data.purpose || "";
            
            // Set the current status from the loaded requisition
            if (data.status !== undefined) {
              // Update the currentStatus ref from setup()
              this.currentStatus = data.status;
            }
            
            // Check if disbursed amount exists and show warning
            if (data.disburse_amount && parseFloat(data.disburse_amount) > 0) {
              toast.warning("This requisition has disbursed amount. Editing may be restricted.", {
                timeout: 5000,
              });
            }
            
            this.items = (data.details || []).map((detail) => ({
              id: detail.id,
              description: detail.description,
              amount: parseFloat(detail.amount),
            }));
          } else {
            toast.error("Requisition data not found");
            this.$router.push({ name: "money-requisition-record" });
          }
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || "Failed to load requisition");
          this.$router.push({ name: "money-requisition-record" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        purpose: yup.string().nullable().label("Project"),
        employee_id: yup.number().positive().integer().nullable().label("Employee"),
      }),
    });

    const employee_id = useField("employee_id");
    const purpose = useField("purpose");
    const errorMessages = ref("");
    const loading = ref(false);
    const buttonText = ref("Save");
    buttonText.value = "Save";
    const store = useStore();
    const router = useRouter();
    const currentStatus = ref(0); // Track current status (0 = DRAFT, 1 = POST)
    const currentButton = ref(null); // Track which button was clicked

    const submitWithItems = (values, itemsArray) => {
      if (!itemsArray || itemsArray.length === 0) {
        toast.error("Please add at least one item");
        return;
      }

      // Validate employee_id
      if (!values.employee_id) {
        toast.error("Please select an employee");
        return;
      }

      const submitData = {
        purpose: values.purpose || null,
        status: currentStatus.value,
        employee_id: values.employee_id,
        items: itemsArray.map((item) => ({
          id: item.id || null, // Include id for existing items, null for new items
          description: item.description,
          amount: parseFloat(item.amount),
        })),
      };

      // If editing, add id to the data object (used by store to determine update vs create)
      const id = router.currentRoute.value.query.id;
      if (id) {
        submitData.id = parseInt(id);
      }

      loading.value = true;
      store
        .dispatch("saveUpdateMoneyRequisition", submitData)
        .then((response) => {
          const isUpdate = !!id;
          resetForm();
          buttonText.value = "Save";
          toast.success(
            response.data?.message || 
            (isUpdate ? "Money Requisition updated successfully" : "Money Requisition created successfully"),
            {
              timeout: 3000,
            }
          );
          store.dispatch("getMoneyRequisitionList");
          setTimeout(() => {
            router.push({ name: "money-requisition-record" });
          }, 1500);
        })
        .catch((error) => {
          const errorMessage = error.response?.data?.message || 
            (id ? "Failed to update money requisition" : "Failed to create money requisition");
          toast.error(errorMessage);
        })
        .finally(() => {
          loading.value = false;
          currentButton.value = null;
        });
    };

    const submit = handleSubmit((values) => {
      // This will be called with items from the template
      submitWithItems(values, []);
    });

    const submitForm = (status, itemsArray) => {
      currentStatus.value = status;
      // Set which button was clicked
      const id = router.currentRoute.value.query.id;
      if (id) {
        currentButton.value = 'update';
      } else {
        currentButton.value = status === 0 ? 'draft' : 'post';
      }
      const formSubmit = handleSubmit((values) => {
        submitWithItems(values, itemsArray);
      });
      formSubmit();
    };

    return {
      submitForm,
      submit,
      submitWithItems,
      employee_id,
      purpose,
      errorMessages,
      buttonText,
      loading,
      currentStatus,
      currentButton,
    };
  },
};
</script>

<style scoped>
.table-dotted-border-bottom {
  border: 1px solid #e0e0e0;
}
.item-info-form {
  margin: 16px 0;
}
.v-container.pb-0 {
  padding-bottom: 0 !important;
}
</style>
